import React from "react";
import "./RE.css";
import reimag from "../../../Gallery/ServicesImages/RE/re.png";

function RE() {
  return (
    <div className="re-wrapper">

      {/* ------------ HERO SECTION ------------ */}
      <section className="re-hero">
        <div className="re-hero-content">
          <h1>
            Precision Re-Creation <br />
            Through Advanced Scanning
          </h1>
          <p>Ideal for reproducing, refining, or enhancing existing components</p>

      
        </div>
      </section>

      {/* ------------ WHAT IS REVERSE ENGINEERING ------------ */}
      <section className="re-info">
        <h2>What Is Reverse Engineering?</h2>

        <p>
          Reverse engineering is the process of analyzing an existing part to
          understand its dimensions, geometry, and design intent. Using
          high-accuracy 3D scanning, the physical object is captured and
          transformed into a detailed CAD model. This enables part reproduction,
          redesign, fitment correction, and improvements even when original data
          or drawings are unavailable.
        </p>
      </section>

      {/* ------------ APPLICATIONS ------------ */}
      <section className="re-applications">
        <div className="re-title-block">
          <span className="circle"></span>
          <h2>Applications</h2>
        </div>

        <p>
          Reverse engineering is commonly used to recreate discontinued parts,
          update outdated designs, enhance performance, or verify the accuracy of
          existing components. It helps restore damaged parts, optimize designs,
          and support manufacturing where legacy documentation no longer exists.
        </p>
      </section>

      {/* ------------ PROCESS SECTION ------------ */}
      <section className="re-process">
        <h2>How Does It Work?</h2>

        <p className="process-line">
          Reverse Engineering Workflow:{" "}
          <strong>Object → 3D Scan → CAD Modeling → Validation → Manufacturing</strong>
        </p>

        <div className="process-img-box">
          <img src={reimag} alt="Reverse Engineering Process" />
        </div>
      </section>

    </div>
  );
}

export default RE;
